import React, { ReactNode, useEffect, useRef } from 'react';

import { Diary } from '../../../../type/recipe';
import { useIntersecting } from '../../../../utils/hook/hook';
import { useHistoryMethod } from '../../../../utils/hook/useHistoryMethod';
import { useRouterQuery } from '../../../../utils/hook/useRouterQuery';
import useScrollSnap from '../../../../utils/hook/useScrollSnap';
import { DiaryShortsModalQuery } from '../components/DiaryShortsModal';

import { useDiaryShortsContext } from './_DiaryShortsRoot';

const _DiaryShortsHorizontalPhotoWrapper = ({
  diary,
  render,
}: {
  diary: Diary;
  render: (photo: string, index: number) => ReactNode;
}) => {
  const { diaryPhotoIndexMap, setDiaryPhotoIndexMap } = useDiaryShortsContext();
  const ref = useRef<HTMLDivElement | null>(null);
  const diaryPhotoWrapperRef = useRef<HTMLDivElement | null>(null);
  const history = useHistoryMethod();
  const { query, stringify } = useRouterQuery<DiaryShortsModalQuery>();

  // 가로 snap 스크롤이 완료되면, Map의 diary.id에 photoIndex를 저장함
  const onChangeIndex = (photoIndex: number) => {
    if (diaryPhotoIndexMap.get(diary.id) === photoIndex) return;

    setDiaryPhotoIndexMap((prev) => new Map(prev).set(diary.id, photoIndex));
  };

  useScrollSnap({
    ref,
    targetArray: diary.photos,
    type: 'HORIZONTAL',
    onChangeIndex,
  });

  const isIntersecting = useIntersecting(diaryPhotoWrapperRef, {
    threshold: 0.5,
  });

  // 다음 슬라이드로 넘어갈때 shortsDiaryId replace
  useEffect(() => {
    if (!isIntersecting || query.shortsDiaryId === diary.id) return;

    history.replace(`?${stringify({ shortsDiaryId: diary.id })}`);
  }, [isIntersecting]);

  return (
    <div
      ref={diaryPhotoWrapperRef}
      key={diary.id}
      className={`h-[100vh] shrink-0 snap-start snap-always bg-black`}
    >
      <div
        ref={ref}
        className="flex h-[100dvh] max-w-[100vw] snap-x snap-mandatory overflow-x-scroll scrollbar-hide"
      >
        {diary.photos.map(render)}
      </div>
    </div>
  );
};

export default _DiaryShortsHorizontalPhotoWrapper;
